/*
 * @Author: Json Chen
 * @Date: 2021-07-02 15:20:13
 * @LastEditTime: 2022-06-13 15:08:46
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLanguage/Components/ActionButtons.tsx
 */

import GlobalButton from '@/src/components/Antd/Button/Button';
import {
  DownloadOutlined,
  // InfoCircleOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import React from 'react';
import { GreenHref } from 'src/components/Link/GreenLink';
import Import from 'src/constrains/Import';
import ModalHOC from 'src/constrains/ModalHOC';
import styles from '../style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ActionButtons = ModalHOC((props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    modalOp,
    updatePage,
    downloadUrl,
    uploadUrl,
    downloadText,
    disableImport,
    disableExport,
  } = props;
  const { setShowModal, setModalTitle, setModalContent } = modalOp;

  const onModalCancel = () => {
    setShowModal(false);
    setModalContent(null);
  };

  const importOnSuccess = () => {
    updatePage();
    onModalCancel();
    //refresh
  };
  const importFun = () => {
    setShowModal(true);
    setModalContent(
      <Import
        onCancel={onModalCancel}
        onSuccess={importOnSuccess}
        downloadUrl={downloadUrl}
        uploadUrl={uploadUrl}
        downloadText={downloadText}
        modalOkText={getI18n('general.import')}
        formDataKey={'file'}
      />,
    );
    setModalTitle(getI18n('salesChannelLanguage.index.importTranslations'));
  };

  return (
    <>
      <GlobalButton
        type='text'
        className={styles.actionsImport}
        onClick={importFun}
        icon={<DownloadOutlined />}
        disabled={disableImport}>
        {getI18n('general.import')}
      </GlobalButton>

      <div className={styles.actionsExport}>
        <UploadOutlined />
        <GreenHref
          download
          target='_blank'
          href={`${downloadUrl}`}
          disabled={disableExport}>
          {getI18n('general.export')}
        </GreenHref>
      </div>
    </>
  );
});

export default ActionButtons;
